exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-09981d35],h2[data-v-09981d35]{font-weight:400}.texy[data-v-09981d35]{margin-top:7px}.plexy[data-v-09981d35]{margin-top:10px}.grid-cont[data-v-09981d35]{display:grid;grid-template-columns:auto auto auto auto;width:400px;border-radius:3px;overflow:hidden;border:1px solid #3b3b3b}.grid-item[data-v-09981d35]{text-align:center;color:#fff;background-color:#292929;padding:2px}.grid-item[data-v-09981d35]:hover{cursor:pointer;background-color:#353535}.grid-header[data-v-09981d35]{background-color:#1f1f1f}.grid-header[data-v-09981d35]:hover{cursor:auto;background-color:#1f1f1f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09981d35","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 11
// module chunks = 0